<template>
  <div class="">
    <ListCard
      :name="'My Stocks'"
      :type="'_mystock'"
      :data="packageDetailInfo?.stocks"
      :loading="loading"
      :activeSymbol="symbol"
      @clickSymbol="
        (eSymbol) => {
          symbol = eSymbol;
        }
      "
    />

    <q-card
      class="row q-mt-sm q-pa-sm justify-around"
      :class="this.$q.dark.mode === true ? '' : 'bg-grey-1 '"
    >
      <div>
        <q-btn
          @click="stockDialog = true"
          color="green"
          icon="add"
          style="font-size: 9px"
        >
          <q-tooltip
            transition-show="scale"
            transition-hide="scale"
            class="bg-green"
            >Click to add Stock</q-tooltip
          >
        </q-btn>

        <q-dialog v-model="stockDialog">
          <q-card style="max-width: 55vh">
            <q-bar :class="this.$q.dark.mode === true ? '' : 'bg-grey-1 '">
              <div
                class="text-h6"
                :class="this.$q.dark.mode === true ? '' : 'text-primary '"
              >
                Add Stock
              </div>

              <q-space />
              <q-btn
                class="q-px-xs q-mx-sm"
                flat
                v-close-popup
                text-color="red"
                dense
                label="close"
                icon="close"
              >
                <q-tooltip class="bg-white text-primary">Close</q-tooltip>
              </q-btn>
            </q-bar>

            <q-separator />

            <div style="max-height: 55vh" class="scroll q-pa-sm">
              <div class="q-ma-sm">
                <q-card bordered class="q-pa-md">
                  <q-select
                    :menu-absolute="true"
                    outlined
                    class="q-mb-md"
                    :class="this.$q.dark.mode === true ? '' : 'bg-grey-1 '"
                    v-model="selectedStock.model"
                    single
                    dense
                    clearable
                    use-input
                    input-debounce="0"
                    :options="options"
                    option-value="symbol"
                    option-label="symbol"
                    emit-value
                    stack-label
                    map-options
                    label="Select Stock"
                    style="min-width: 250px; max-width: 500px"
                    @filter="filterFn"
                  >
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-grey">
                          No results
                        </q-item-section>
                      </q-item>
                    </template>
                  </q-select>

                  <div class="q-pt-s">
                    <div
                      class="text- q-px-xs"
                      :class="this.$q.dark.mode === true ? '' : 'text-primary '"
                    >
                      Create your own Buy Sell Target... You will be notify the
                      target in real time
                      <span class="text-cyan-4"> (Optional) </span><br />

                      <span class="q-py-md text-red-4 text-caption">
                        Please set value above 150
                      </span>
                    </div>
                    <q-input
                      class="q-my-sm"
                      :class="this.$q.dark.mode === true ? '' : 'bg-grey-1 '"
                      type="number"
                      min="0"
                      oninput="validity.valid||(value='');"
                      dense
                      outlined
                      v-model="selectedStock.buy_target"
                      label="Set Buy Target"
                    />
                    <q-input
                      class="q-my-sm"
                      :class="this.$q.dark.mode === true ? '' : 'bg-grey-1 '"
                      type="number"
                      min="0"
                      oninput="validity.valid||(value='');"
                      dense
                      outlined
                      v-model="selectedStock.sell_target"
                      label="Set Sell Target"
                    />
                  </div>
                </q-card>

                <q-btn
                  class="q-mt-md"
                  :color="this.$q.dark.mode === true ? 'grey-9' : 'primary '"
                  @click="postAndReloadStocks"
                  label="Submit"
                  :disable="!selectedStock.model"
                />
              </div>
            </div>

            <q-separator></q-separator>
          </q-card>
        </q-dialog>
      </div>

      <div>
        <q-btn
          style="font-size: 9px"
          color="red"
          icon="delete"
          @click="stockDeleteDialog = true"
        >
          <q-tooltip
            transition-show="scale"
            transition-hide="scale"
            class="bg-red"
            >Click to delete Stock</q-tooltip
          >
        </q-btn>

        <q-dialog v-model="stockDeleteDialog">
          <q-card style="max-width: 55vh">
            <q-bar :class="this.$q.dark.mode === true ? '' : 'bg-grey-1 '">
              <div
                class="text-h6"
                :class="this.$q.dark.mode === true ? '' : 'text-primary'"
              >
                Delete Stock
              </div>

              <q-space />
              <q-btn
                class="q-px-xs q-mx-sm"
                flat
                v-close-popup
                text-color="red"
                dense
                label="close"
                icon="close"
              >
                <q-tooltip class="bg-white text-primary">Close</q-tooltip>
              </q-btn>
            </q-bar>

            <q-separator />

            <div style="max-height: 55vh" class="scroll q-pa-sm">
              <div class="q-ma-sm">
                <q-card bordered class="q-pa-md">
                  <q-select
                    :menu-absolute="true"
                    outlined
                    class="q-mb-md"
                    :class="this.$q.dark.mode === true ? '' : 'bg-grey-1 '"
                    v-model="deleteStockModel"
                    single
                    dense
                    clearable
                    use-input
                    input-debounce="0"
                    :options="packageDetailInfo?.stocks"
                    option-value="symbol"
                    option-label="symbol"
                    emit-value
                    stack-label
                    map-options
                    label="Select Stock"
                    style="min-width: 250px; max-width: 500px"
                    @filter="filterFn"
                  >
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-grey">
                          No results
                        </q-item-section>
                      </q-item>
                    </template>
                  </q-select>
                </q-card>

                <q-btn
                  class="q-mt-md"
                  color="red"
                  @click="deleteAndReloadStocks"
                  label="Delete"
                  :disable="!deleteStockModel"
                />
              </div>
            </div>

            <q-separator></q-separator>
          </q-card>
        </q-dialog>
      </div>

      <div>
        <q-btn
          @click="stockTargetDialog = true"
          color="primary"
          icon="edit"
          style="font-size: 9px"
        >
          <q-tooltip
            transition-show="scale"
            transition-hide="scale"
            class="bg-primary"
            >Click to Edit Stock Buy Sell Target</q-tooltip
          >
        </q-btn>

        <q-dialog v-model="stockTargetDialog">
          <q-card style="max-width: 50vh">
            <q-bar :class="this.$q.dark.mode === true ? '' : 'bg-grey-1 '">
              <div
                class="text-h6"
                :class="this.$q.dark.mode === true ? '' : 'text-primary '"
              >
                Edit Target
              </div>

              <q-space />
              <q-btn
                class="q-px-xs q-mx-sm"
                flat
                v-close-popup
                text-color="red"
                dense
                label="close"
                icon="close"
              >
                <q-tooltip class="bg-white text-primary">Close</q-tooltip>
              </q-btn>
            </q-bar>

            <q-separator />

            <div style="max-height: 60vh" class="scroll q-pa-sm">
              <div class="q-ma-sm">
                <q-card bordered class="q-pa-md">
                  <q-select
                    :menu-absolute="true"
                    outlined
                    class="q-mb-md"
                    :class="this.$q.dark.mode === true ? '' : 'bg-grey-1 '"
                    v-model="selectedStockTargetModel"
                    single
                    dense
                    clearable
                    use-input
                    input-debounce="0"
                    :options="packageDetailInfo?.stocks"
                    @update:model-value="
                      onSelectIndex(selectedStockTargetModel)
                    "
                    option-value="symbol"
                    option-label="symbol"
                    emit-value
                    stack-label
                    map-options
                    label="Select Stock"
                    style="min-width: 250px; max-width: 500px"
                    @filter="filterFnTarget"
                  >
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-grey">
                          No results
                        </q-item-section>
                      </q-item>
                    </template>
                  </q-select>

                  <div class="q-pt-s">
                    <div
                      class="text-caption q-px-xs"
                      :class="this.$q.dark.mode === true ? '' : 'text-primary '"
                    >
                      <span class="text-body2"> Edit Your Buy Sell Target</span>
                      <br />
                      <span class="q-py-md text-red-4 text-caption">
                        Please set value above 150
                      </span>
                    </div>
                    <q-input
                      class="q-my-sm"
                      :class="this.$q.dark.mode === true ? '' : 'bg-grey-1 '"
                      type="number"
                      min="0"
                      oninput="validity.valid||(value='');"
                      dense
                      outlined
                      v-model="selectedStockTarget.buy_target"
                      label="Set Buy Target"
                    />
                    <q-input
                      class="q-my-sm"
                      :class="this.$q.dark.mode === true ? '' : 'bg-grey-1 '"
                      type="number"
                      min="0"
                      oninput="validity.valid||(value='');"
                      dense
                      outlined
                      v-model="selectedStockTarget.sell_target"
                      label="Set Sell Target"
                    />

                    <q-list>
                      <q-item>
                        <q-item-section>
                          <q-item-label>Send Notification</q-item-label>
                        </q-item-section>
                        <q-item-section avatar>
                          <q-toggle
                            color="green"
                            size="sm"
                            v-model="selectedStockTarget.send_notification"
                          />
                        </q-item-section>
                      </q-item>
                    </q-list>
                  </div>
                </q-card>

                <q-btn
                  class="q-mt-md"
                  :color="$q.dark.mode === true ? 'grey-9' : 'primary'"
                  @click="updateTarget()"
                  label="Update"
                  :disable="!selectedStockTargetModel"
                />
              </div>
            </div>

            <q-separator></q-separator>
          </q-card>
        </q-dialog>
      </div>

      <div>
        <q-btn
          @click="syncWithMeroworthDialog = true"
          color="deep-orange"
          icon="sync"
          style="font-size: 9px"
        >
          <q-tooltip
            transition-show="scale"
            transition-hide="scale"
            class="bg-deep-orange"
            >click to sync stocks with meroworth</q-tooltip
          >
        </q-btn>

        <q-dialog v-model="syncWithMeroworthDialog">
          <q-card style="max-width: 50vh">
            <q-bar :class="this.$q.dark.mode === true ? '' : 'bg-grey-1 '">
              <div
                class="text-h6"
                :class="this.$q.dark.mode === true ? '' : 'text-primary '"
              >
                Sync with Meroworth
              </div>

              <q-space />
              <q-btn
                class="q-px-xs q-mx-sm"
                flat
                v-close-popup
                text-color="red"
                dense
                label="close"
                icon="close"
              >
                <q-tooltip class="bg-white text-primary">Close</q-tooltip>
              </q-btn>
            </q-bar>

            <q-separator />

            <div style="max-height: 60vh" class="scroll q-pa-sm">
              <div class="q-ma-xs">
                <q-card class="q-pa-sm">
                  <p>If you have Stocks on Meroworth sync with My Signals</p>
                </q-card>
                <q-btn
                  class="q-mt-md"
                  :color="$q.dark.mode === true ? 'grey-9' : 'primary'"
                  size="sm"
                  @click="onClickSyncMeroWorth"
                  label="Sync"
                />
              </div>
            </div>

            <q-separator></q-separator>
          </q-card>
        </q-dialog>
      </div>
    </q-card>
  </div>
</template>

<script>
import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import useMembership from "src/use/membership";
import useCore from "src/use/core";
import { useQuasar, LocalStorage } from "quasar";
import ListCard from "src/components/ListCard.vue";

export default {
  emits: ["chartSymbol", "emitChartData"],
  name: "MySignalList",

  components: {
    ListCard,
  },

  setup(props, context) {
    const store = useStore();
    const {
      getMySignals,
      postPackage,
      deleteStock,
      syncMeroWorth,
      getMySignalswithTarget,
      UpdateMySignalswithTarget,
    } = useMembership();
    const { getPackage } = useMembership();
    const { allStock } = useCore();
    const $q = useQuasar();
    const symbol = ref(null);
    const packageDetail = ref(null);
    const loading = ref(true);
    const stocks = ref([]);
    const options = ref([]);
    const selectedStock = ref({});
    const selectedStockTargetModel = ref("");
    const deleteStockModel = ref("");
    const selectedStockTarget = ref({});

    const stockDialog = ref(false);
    const stockDeleteDialog = ref(false);
    const stockTargetDialog = ref(false);
    const syncWithMeroworthDialog = ref(false);

    const packageDetailInfo = ref({});
    const signalsWithTarget = ref([]);
    const signalsWithTargetList = ref([]);

    function onSelectIndex(stock) {
      selectedStockTarget.value = signalsWithTarget.value.filter((item) => {
        return item.symbol === stock;
      })[0];
    }

    const updateTarget = async () => {
      try {
        await UpdateMySignalswithTarget(selectedStockTarget.value).then(() => {
          selectedStockTarget.value = {};
          selectedStockTargetModel.value = "";
          $q.notify({
            type: "positive",
            message: "Stock Updated Successful",
          });
        });
        stockTargetDialog.value = false;
      } catch (error) {
        $q.notify({
          type: "negative",
          message: "Stock Updating Failed",
        });
      }
    };

    function signalClick(item) {
      symbol.value = item;
    }

    if (store.state.authenticate.isAuthenticated) {
      if (LocalStorage.getItem("package") != null) {
        packageDetail.value = LocalStorage.getItem("package");
      } else {
        getPackage()
          .then((res) => {
            packageDetail.value = res.data;
            loading.value = false;
          })
          .catch((err) => {
            packageDetail.value = null;
          });
      }
    }
    function loadData() {
      getPackage().then(async (details) => {
        packageDetailInfo.value = details.data;
        packageDetailInfo.value.stocks.sort();
        symbol.value = packageDetail.value.stocks?.sort()[0];
        stocks.value = await allStock().then((res) => {
          if (details.data.message === "No active package") return res.data;
          if (!details.data.stocks) return res.data;
          return res.data.filter((s) => {
            return !details.data.stocks.includes(s.symbol);
          });
        });
      });
    }

    const postAndReloadStocks = async () => {
      try {
        await postPackage(selectedStock.value);
        $q.notify({
          type: "positive",
          message: "Stock Added Successful",
        });
        selectedStock.value = {};
      } catch (error) {
        $q.notify({
          type: "negative",
          message: "Stock Adding Failed",
        });
      }

      loadData();
      stockDialog.value = false;
    };

    function deleteAndReloadStocks() {
      deleteStock(deleteStockModel.value)
        .then((res) => {
          $q.notify({
            type: "positive",
            message: res.data.message,
          });
        })
        .catch((error) => {
          console.log(error);
          $q.notify({
            type: "negative",
            message: "Stock Deleting Failed",
          });
        });

      loadData();

      deleteStockModel.value = "";
      stockDeleteDialog.value = false;
    }

    function onClickSyncMeroWorth() {
      syncMeroWorth()
        .then((res) => {
          $q.notify({
            type: "positive",
            message: res.data.message,
          });
        })
        .catch((error) => {
          console.log(error);
          $q.notify({
            type: "negative",
            // message:error.message,
            message: "No stocks to sync",
          });
        });

      loadData();

      deleteStockModel.value = "";
      syncWithMeroworthDialog.value = false;
    }

    const emitChartData = computed(() => {
      const data = signalsWithTarget.value.filter(
        (i) => i.symbol === symbol.value
      );
      return data;
    });

    watch(
      () => symbol.value,
      (newVal, oldVal) => {
        if (newVal !== null) {
          context.emit("emitChartData", emitChartData.value);
          context.emit("chartSymbol", newVal);
        }
      }
    );

    onMounted(() => {
      getMySignalswithTarget().then((res) => {
        signalsWithTarget.value = res.data;
        signalsWithTargetList.value = res.data;
      });
      loadData();
    });

    return {
      symbol,
      packageDetail,
      loading,
      stockDialog,
      stockDeleteDialog,
      stockTargetDialog,
      syncWithMeroworthDialog,
      selectedStock,
      selectedStockTarget,
      selectedStockTargetModel,
      deleteStockModel,
      packageDetailInfo,
      stocks,
      postAndReloadStocks,
      signalClick,

      onSelectIndex,
      signalsWithTarget,
      updateTarget,
      deleteAndReloadStocks,
      onClickSyncMeroWorth,
      options,

      filterFn(val, update) {
        if (val === "") {
          update(() => {
            options.value = stocks.value;
          });
          return;
        }

        update(() => {
          const needle = val.toLowerCase();
          options.value = stocks.value.filter((v) => {
            return v.symbol.toLowerCase().indexOf(needle) > -1;
          });
        });
      },

      filterFnTarget(val, update) {
        if (val === "") {
          update(() => {
            signalsWithTarget.value = signalsWithTargetList.value;
          });
          return;
        }

        update(() => {
          const needle = val.toLowerCase();
          signalsWithTarget.value = signalsWithTargetList.value.filter((v) => {
            return v.symbol.toLowerCase().indexOf(needle) > -1;
          });
        });
      },
    };
  },
};
</script>
